import { UserType, PASSCODE_FORMAT } from 'utils/constants';
import getRequestBody from './getRequestBody';

const getPasscodeFromURL = (url: string) => {
  const passcode = decodeURI(url).match(PASSCODE_FORMAT);
  return (passcode && passcode[0]) || undefined;
};

const getSorensonEndpoint = (userType: UserType) => {
  const userTypeEndpoint =
    userType === UserType.VRI
      ? process.env.REACT_APP_SORENSON_URL_VRI
      : process.env.REACT_APP_SORENSON_URL_VRS;

  return `${userTypeEndpoint}`;
};

export { getPasscodeFromURL, getSorensonEndpoint, getRequestBody };
